import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiDatePicker, UiClientSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ExportPDFButton from '../../pdf_table.js';

import { Table } from 'antd';
import { Dropdown, Popconfirm, Menu } from 'antd';
import { getStorage, setStorage, updateFilterUrl } from "../../helper.js";



export default function OutstandingReport() {
  let navigate = useNavigate();
  const location = useLocation();
  const [fy] = useOutletContext();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);





  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    setValue,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])

    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'outstanding-report', 1), { replace: location.search ? true : false })


  };





  const headers = [
    { label: "S.No", key: "sno" },
    { label: "Account", key: "name" },
    { label: "Mobile", key: "mobile" },
    { label: "Amount", key: "balance" },
    { label: "Last Receipt", key: "last_receipt_date" },
  ];

  const pdf_columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      key: 'sno',
      width: 15,
      colspan: 3
    },
    {
      title: 'Account',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      key: 'mobile',
      width: 25
    },
    {
      title: 'Amount',
      dataIndex: 'balance',
      key: 'balance',
      align: 'right',
      width: 25
    },
    {
      title: 'Last',
      dataIndex: 'last_receipt_date',
      key: 'last_receipt_date',
      width: 12
    },
    {
      title: 'Remark',
      dataIndex: ' ',
      key: ' ',
      width: 35
    },


  ];

  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/outstanding_report" + filter
    );

    var dataa = data;

    return dataa;

  }

  const defaultValues = {
    date: null,
  };



  useEffect(() => {
    queryClient.invalidateQueries(['outstanding-report'])
  }, [fy]);


  useEffect(() => {

    if (location.search) {
    } else {
      setFilter(defaultValues)
    }




  }, [location]);



  useEffect(() => {


    const parsed = queryString.parse(location.search);



    setFilter(parsed)




  }, []);


  const columns = [
    {
      title: 'S.No',
      width: '20px',
      dataIndex: 'sno',
      onCell: (a, index) => ({
        colSpan: a.sno == 'Total' ? 3 : 1,
      })
    },
    {
      title: 'Account',
      width: '100px',
      dataIndex: 'name',
      sorter: 'name',
      sortOrder: parsed.sort_by == 'name' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'name' && parsed.sort == 'desc' ? 'descend' : '',
      onCell: (a, index) => ({
        colSpan: a.sno == 'Total' ? 0 : 1,
      })
    },
    {
      title: 'Mobile',
      width: '100px',
      dataIndex: 'mobile',
      onCell: (a, index) => ({
        colSpan: a.sno == 'Total' ? 0 : 1,
      })
    },
    {
      title: 'Amount',
      width: '100px',
      dataIndex: 'balance',
      sorter: 'balance',
      align: 'right',
      sortOrder: parsed.sort_by == 'balance' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'balance' && parsed.sort == 'desc' ? 'descend' : '',
    },

    {
      title: 'Last Receipt',
      width: '80px',
      dataIndex: 'last_receipt_date',

    },



  ];




  const { data, error, isError, isLoading, isFetching } = useQuery(["outstanding-report", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
  });


  const clearSelection = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
  }
  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        date: filter.date ? filter.date : data && data.date ? data.date : null,
        group: zstate.categories && filter.group ? filter.group : '',
        city: filter.city,
      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {

    if (data && data.date) {
      setValue('date', data.date)
    }

  }, [data]);







  const handleTableChange = (pagination, filters, sorter) => {
    var direction = ''

    if (sorter.order == 'ascend') {
      direction = 'asc';
    } else if (sorter.order == 'descend') {
      direction = 'desc';
    }

    let currentUrlParams = new URLSearchParams(window.location.search);

    if (sorter.order) {
      currentUrlParams.set('sort_by', sorter.field);
      currentUrlParams.set('sort', direction);
    } else {
      currentUrlParams.delete('sort_by');
      currentUrlParams.delete('sort');
    }


    if (location.search) {
      navigate('/outstanding-report?' + currentUrlParams.toString(), { replace: true })
    } else {
      navigate('/outstanding-report?' + currentUrlParams.toString())
    }




  };
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedRows)
  };
  const rowSelection = {
    getCheckboxProps: (record) => ({
      // Disable checkbox for the last row
      disabled: record.sno === 'Total' // Replace with condition to identify the last row
    }),
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };


  const msgModal = useModal('send_wa');

  const sendMsg = (numbers, date) => {
    msgModal.show({ contacts: numbers, type: 'outstanding', date }).then((res) => {
      clearSelection()
    });
  }





  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Outstanding Report
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Outstanding Report" >
            {data.items &&
              <><ExportPDFButton columns={pdf_columns} lastbold={true} data={data.items} title="outstanding-report" company={data.company} company_desc={data.company_desc} heading2="Outstanding Report" topleft={data.staff ? 'Name: ' + data.staff + ' ' + data.city : ''} topright={`As on ${data.date}`} />

                <ExportPDFButton columns={pdf_columns} lastbold={true} data={data.items} title="outstanding-report" company={data.company} company_desc={data.company_desc} heading2="Outstanding Report" topleft={data.staff ? 'Name: ' + data.staff + ' ' + data.city : ''} topright={`As on ${data.date}`} action="send" type="Outstanding Report" className="ms-2" />

                <CSVLink data={data.items} filename={"outstanding-report.csv"} headers={headers} className={`btn btn-outline-primary d-inline-flex mx-2 ${data.items.length == 0 && 'disabled'}`} >Export</CSVLink>
              </>
            }


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4 pb-4">
            <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
              <div className="p-3 pb-0">

                <div className="row">

                  <div className="col-md-2">

                    <Controller

                      name="date"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          required={true}
                          label="Date"
                          onChange={onChange}
                          default_val={value}
                          message={errors.date?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>

                  <div className="col-md-3">
                    <Controller
                      name="group"
                      control={control}
                      render={({ field }) => (

                        <UiSelect
                          options={zstate.categories}
                          className=""
                          message={errors.group?.message}
                          label="Group"
                          {...field}
                        />

                      )}
                    />
                  </div>


                  <div className="col-md-2">
                    <Controller
                      name={`staff`}
                      control={control}
                      render={({ field }) => (

                        <UiClientSelect
                          {...field}
                          parentClass="mb-1"
                          className=""
                          category={[26]}
                          fetch_onload
                          message={errors.staff?.message}
                          label="Staff"

                        />

                      )}
                    />
                  </div>
                  <div className="col-md-2">

                    <UiInput
                      label="City"
                      type="text"
                      name="city"
                      {...register("city")}
                      message={errors.city?.message}
                    />
                  </div>
                  <div className="col-md-1" style={{ paddingTop: '28px' }}>
                    <div className="d-flex justify-content-end">

                      <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                    </div>

                  </div>
                </div>



              </div>
            </form>

            <div style={{ height: '34px' }} className="ps-3">
              {selectedRowKeys && selectedRowKeys.length > 0 && (
                <div className="bulkaction">
                  <div>
                    {data.send_whatsapp == 1 &&
                      <button className="btn btn-outline-primary btn-sm me-2" onClick={() => sendMsg(selectedRows, data.date)}  >Send Message</button>
                    }
                    <button className="btn btn-light btn-sm me-2" onClick={() => clearSelection()}>Clear Selection <div className="badge bg-primary">{selectedRowKeys.length}</div></button>

                  </div>
                </div>
              )}
            </div>


            <Table
              locale={{
                emptyText: (<TableZero title="Parties" />)
              }}

              size="small"
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={data.items}
              pagination={false}
              loading={{ spinning: (tableDisable || isFetching) }}
              rowSelection={rowSelection}
              rowClassName={(sa) => sa.sno == 'Total' && 'fw-bold bg-light'}
              onChange={handleTableChange}
              scroll={{
                x: 960,

              }}
            />

          </div>
        </div>
      </div>
    </>
  );
}
